import updateValue from './update-value'
import set from './set'

/* Method used throughout the app to updated a property via a component
 ** Use case ex: validateEmail('thb@gmail.com)"
 ** return a boolean true or false if the email is valid or invalid
*/

export const validateEmail = value => {
  /* eslint-disable-next-line */
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

  return regex.test(value)
}

export const validateName = (value = '') => {
  const regex = /^[A-Za-z\s]{1,20}$/
  return value.trim().length > 2 && regex.test(value)
}

export const validatePassword = password => /^(?=.*\d)(?=.*[a-z])(?=.*[a-zA-Z]).{6,}$/.test(password)

export const formatNumber = (num, fixed = 2) => Number(num).toFixed(fixed)

export const convertToPercentage = (num, fixed = 2, requiredSymbol = true) => {
  const per = num * 100
  if (per === 100) return `100${requiredSymbol ? '%' : ''}`
  return `${formatNumber(per, fixed)}${requiredSymbol ? '%' : ''}`
}

export {
  updateValue,
  set
}
